import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@nibtravel/shared/ui/components/button';
import { IconModule } from '@nibtravel/shared/ui/components/icon';
import { NgxContentfulRichTextModule } from 'ngx-contentful-rich-text';

import { AccordionComponent } from './accordion.component';

@NgModule({
  imports: [
    CommonModule,
    NgxContentfulRichTextModule,
    ButtonModule,
    IconModule,
  ],
  declarations: [AccordionComponent],
  exports: [AccordionComponent],
})
export class AccordionModule {}
